import React from 'react';
import { ContentWrapper } from '../../shared/ContentWrapper/ContentWrapper';
import { OnboardingController } from '../../components/Onboarding/OnboardingController';
import {
  BusinessFormMainWrapper,
  BusinessFormWrapper,
} from './BusinessForm.styled';

export const BusinessForm = () => {
  return (
    <>
      <BusinessFormMainWrapper>
        <ContentWrapper>
          <BusinessFormWrapper>
            <OnboardingController />
          </BusinessFormWrapper>
        </ContentWrapper>
      </BusinessFormMainWrapper>
    </>
  );
};
